import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { sidebarData } from '../../../utils/data'
import styles from './Sidebar.module.scss'
import replaceText from '../../../../common/utils/replaceText'

const Sidebar = ({ tokens }) => {
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: { extension: { regex: "/(jpg)|(png)|(jpeg)/" } }) {
        edges {
          node {
            base
            childImageSharp {
              gatsbyImageData
            }
          }
        }
      }
    }
  `)

  const imageMap = {}
  data?.allFile?.edges?.forEach((img) => {
    imageMap[img.node.base] = img.node.childImageSharp.gatsbyImageData
  })

  return (
    <>
      {sidebarData.map((item) => {
        return (
          <a
            key={item.link}
            href={item.link}
            target="_blank"
            rel="nofollow noopener noreferrer"
          >
            <div
              key={item.title}
              className={`${styles.sidebar} d-flex align-items-center justify-content-between `}
              style={{ background: item.color }}
            >
              <span className={styles.anchor}>
                <strong>Free </strong>
                {item.title}{' '}
              </span>
              <span>
                <GatsbyImage
                  loading="lazy"
                  alt={replaceText(tokens, item.title)}
                  className="test-img"
                  image={getImage(imageMap[item.img])}
                />
              </span>
            </div>
          </a>
        )
      })}
    </>
  )
}

export default Sidebar
